/* eslint-disable no-inner-declarations */
import React, { useEffect, useState, createContext } from "react";
import PropTypes from 'prop-types';
import { poolData, appf_tenant_info } from "./UserPool";
import { getProjectStore } from "./store/projectStore";
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { AuthenticationDetails, CognitoUser } from 'amazon-cognito-identity-js';
import KeyCloak from './KeyCloak';
import { initializeApp } from "firebase/app";
import { getAuth, signOut, signInWithEmailAndPassword } from "firebase/auth";
import { APPFACTOR } from "./components/commons"
import { jwtDecode } from "jwt-decode";

const authContext = createContext();
const kInstance = []
function internalCleanup(){
  try {
    Object.keys(localStorage).forEach(k => {
      try {
        if( k != "eula" && k != "savedAppDesign"){
          delete localStorage[k]
        }
      } catch (e) {/* */}
    })

    Object.keys(sessionStorage).forEach(k => {
      try {
        delete sessionStorage[k]
      } catch (e) {/* */}
    })
  } catch (e) {/* */ }

  try{
    getProjectStore().setProjectContext({
      currentProjectId: window._g._DEFAULT_PROJECT_ID,
      currentSEnv: window._g._DEFAULT_SOURCE_ENV_ID,
      projects: null,
      sEnv: null,
    });
  }catch(e){/**/}
}

function useAuth() {
  const [authed, setAuthed] = useState(false);
  const [newPass, setNewPass] = useState(false);
  const [userPool, setUserPool] = useState(null);
  
  const api =
  {
    initConfig: () => {
    },
    getUserPool: ()=>{
      return userPool;
    },
    accessToken: "",
    authed,
    logout: () => {
      internalCleanup();

      const user = userPool.getCurrentUser();
      if (user) {
        user.signOut();
      }
      setAuthed(false);
      window.location.pathname="/";
      setTimeout(() => {
        window.location.reload()
      }, 10);

    },
    setPool: (poolId, clientId) => {
      if (typeof poolId !== 'undefined') {
        poolData.UserPoolId = poolId;
        poolData.ClientId = clientId;
      }
    },
    validateSession: (err, session, reject, resolve) => {
      if (err) {
        setAuthed(false);
        reject(err);
      } else {
        if (poolData.accessToken !== session.accessToken.jwtToken) {
          // try{
          //   console.log("NEW - ",poolData?.accessToken?.slice(-4) , session.accessToken.jwtToken.slice(-4) ) ;
          // }catch(e){/**/}
          poolData.session = session;
          // The Forge gateway authenticates with the ID token, not the access
          // token - it checks `aud` against the pool's app client id, which a
          // Cognito access token does not carry. Same session, so it rotates
          // with the access token on every refresh through here.
          try { poolData.idToken = session.idToken.jwtToken; } catch (e) { poolData.idToken = ""; }
          poolData.accessToken = session.accessToken.jwtToken;
          api.accessToken = session.accessToken.jwtToken
        }
        // else{console.log("SAME - ", poolData.accessToken.slice(-4)  );}
        if (!authed) {
          setAuthed(true);
        }
        resolve(session);
      }
    },
    refreshToken: () => {
      let userPoolLocal = userPool;
      /*
      try{
        const decoded = jwtDecode(poolData.accessToken);
        let force = false;
  
         function timeTo(futureTime) {
          let ct = new Date();
  
          let td = futureTime.getTime() - ct.getTime();
          td = td / 1000;
          let seconds = Math.floor(td % 60); 
          let secondsAsString = seconds < 10 ? "0" + seconds : seconds + "";
          td = Math.floor(td / 60);
          let minutes = td % 60;
          let minutesAsString = minutes < 10 ? "0" + minutes : minutes + "";
          td = Math.floor(td / 60);
          let hours = td % 24;
          td = Math.floor(td / 24);
          let days = td;
  
          let totalHours = hours + (days * 24);
          let totalHoursAsString = totalHours < 10 ? "0" + totalHours : totalHours + "";
  
          if (totalHoursAsString === "00") {
              return minutesAsString + ":" + secondsAsString;
          } else {
              return totalHoursAsString + ":" + minutesAsString + ":" + secondsAsString;
          }
         }
  
  
      let expTime = new Date(decoded.exp * 1000);
        console.log(timeTo( expTime ) ,expTime.getTime() - (new Date()).getTime(),expTime.getTime() , expTime)
        if (Date.now() >= decoded.exp * 1000) {
          force = true;
        }
        if(force){
          ///
        }
      }catch(e){ console.log(e) }
      */


      if (!userPoolLocal) {
        userPoolLocal = new CognitoUserPool({ ...poolData })
      }

      userPoolLocal.getCurrentUser().
        getSession((err, session) => {
          api.validateSession(err, session, () => {
            console.log("error refreshing token")
          }, () => {
            // console.log("success refreshing token")
          });

          if (userPoolLocal !== userPool) {
            setUserPool(userPoolLocal);
          }
        });
    },

    refreshTokenTask() {
      setTimeout(() => {
        api.refreshToken()
      }, 5000);
    },

    getSession: async (poolId, clientId) => {
      let userPoolLocal = userPool;

      if (typeof poolId !== 'undefined') {
        poolData.UserPoolId = poolId;
        poolData.ClientId = clientId;
        userPoolLocal = new CognitoUserPool({ ...poolData });
      } else {
        userPoolLocal = new CognitoUserPool({ ...poolData })
      }

      return await new Promise((resolve, reject) => {
        const user = userPoolLocal.getCurrentUser();
        if (user) {

          user.getSession((err, session) => {
            api.validateSession(err, session, reject, resolve);
          });

          setUserPool(userPoolLocal);

        } else {
          setAuthed(false);
          reject();
        }
      });
    },
    login: async (Username, Password, poolId, clientId) => {
      return await new Promise((resolve, reject) => {
        if (typeof poolId === 'undefined' || typeof clientId == 'undefined' || poolId == '' || clientId == '') {
          poolId = "eu-west-2_TpjF7jx55";
          clientId = "55gf19fprt1vejhb1gt38mhl60";
        }
        let usrPool = new CognitoUserPool({ UserPoolId: poolId, ClientId: clientId });

        const user = new CognitoUser({
          Username,
          Pool: usrPool,
        });

        setUserPool(usrPool);

        const authDetails = new AuthenticationDetails({ Username, Password });

        try {
          user.authenticateUser(authDetails, {
            mfaRequired: function () {
            },
            totpRequired: function () {
            },
            customChallenge: function () {
            },
            mfaSetup: function () {
            },
            selectMFAType: function () {
            },
            onSuccess: (result) => {
              setAuthed(true);
              setUserPool(usrPool);
              api.validateSession(null, result, reject, resolve);
              poolData.session = result;
              // See validateSession: Forge needs the ID token from this same
              // session. Set here too because this path assigns directly rather
              // than relying only on the validateSession call above, which
              // skips its block when the access token has not changed.
              try { poolData.idToken = result.idToken.jwtToken; } catch (e) { poolData.idToken = ""; }
              poolData.accessToken = result.accessToken.jwtToken;
              api.accessToken = poolData.accessToken
              resolve(result);
            },
            onFailure: (err) => {
              setAuthed(false);
              reject(err);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {
              try {
                userAttributes.name = userAttributes.email;

                delete userAttributes.email_verified;
                delete userAttributes.phone_number_verified;
                delete userAttributes.email;
                delete userAttributes.phone_number;
                delete userAttributes.phone_number;
              } catch (e) {
                console.log(e);
              }

              let retVal = {
                requiredAttributes: requiredAttributes,
                userAttributes: userAttributes,
                userData: user,
                newPass: true
              }

              if (!newPass) {
                setNewPass(true);
              }

              setAuthed(false);

              resolve(retVal);
            },
          });
        } catch (e) {
          console.log(e);
        }
      });
    }
  };

  return api
}

function useAuthStandalone() {
  const [authed, setAuthed] = useState(false);
  return {
    initConfig: () => {
    },
    accessToken: localStorage.token,
    authed,
    logout: () => {
      internalCleanup();


      let keyCloak = kInstance[0];
      
      if(  kInstance.length == 0){
         kInstance.push(new KeyCloak());
         keyCloak = kInstance[0];
      }

      keyCloak.logout().then(() => {
        setAuthed(false);
      }).catch(err => {
        setAuthed(false);
        console.log("Logout error", err);
      });
    },
    getSession: async () => {
      poolData.accessToken = localStorage.token; 
      let keyCloak = kInstance[0];
      
      if(  kInstance.length == 0){
         kInstance.push(new KeyCloak());
         keyCloak = kInstance[0];
      }

      return await new Promise((resolve, reject) => {
        keyCloak.getSession().then(session => {
          if (session && session.sub) {
            setAuthed(true);
            resolve(session)
          }
          else {
            setAuthed(false);
            reject();
          }
        }).catch(err => {
          console.log("Session error", err);
          reject();
        })
      });
    },
    refreshToken:()=>{
       poolData.accessToken = localStorage.token; 
    },
    login: async (Username, Password) => {
     let localPool = poolData;
     let keyCloak = kInstance[0];
      
     if(  kInstance.length == 0){
        kInstance.push(new KeyCloak());
        keyCloak = kInstance[0];
     }
     

      return await new Promise((resolve, reject) => {
        keyCloak.login(Username, Password).then(data => {
          if (data) {
            localStorage.setItem('token', data.access_token);
            localPool.accessToken = data.access_token; 
            localStorage.setItem('refresh_token', data.refresh_token);
            setAuthed(true);
            resolve(data);
          } else {
            setAuthed(false);
            reject({ message: "Invalid login" });
          }
        }).catch(err => {
          console.log("Login error", err);
          reject({ message: "Invalid login" });
        })
      });
    }
  }
}

function useAuthFirebase() {
  const [authed, setAuthed] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [app, setApp] = useState({});
  const [authObj, setAuthObj] = useState({});

  useEffect(() => {
    if (poolData.config) {
      let app = initializeApp(poolData.config, APPFACTOR.appName)
      let authv = getAuth(app);
      setAuthObj(authv);
    }
  }, [])

  return {
    accessToken: localStorage.token,
    refreshToken: async () => {
      const decoded = jwtDecode(poolData.accessToken);
      let force = false;

      if (Date.now() >= decoded.exp * 1000) {
        force = true;
      }

      if (force) {
        authObj.currentUser.getIdToken(force)
          .then(function (returnToken) {
            if (returnToken) {
              poolData.accessToken = returnToken;
            }
          }).catch(() => {/**/ });
      }
    },
    authed,
    initConfig: () => {
    },
    logout: () => {
      internalCleanup();
      
      signOut(authObj);
      localStorage.removeItem('token');
      localStorage.removeItem('tenantData');
      localStorage.removeItem('refresh_token');
      setAuthed(false);
    },
    setPool: () => {
      /**/
    },
    getSession: async () => {
      return await new Promise((resolve, reject) => {
        try {
          let app = initializeApp(poolData.config, APPFACTOR.appName)
          let authv = getAuth(app);

          const unregisterAuthObserver = authv.onAuthStateChanged(user => {
            if (user) {
              if (poolData.accessToken !== user.accessToken) {
                poolData.accessToken = user.accessToken;
              }
              setAuthObj(authv);
              setAuthed(true);
              unregisterAuthObserver();
              resolve(authv)
            }
            else {
              setAuthed(false);
              reject({})
            }
          })

        } catch (e) {
          setAuthed(false);
          reject({})
        }
      })
    },
    login: async (Username, Password) => {
      const poolDataLocal = poolData;

      return await new Promise((resolve, reject) => {

        let app = initializeApp(APPFACTOR.tenantInfo.config, APPFACTOR.appName)
        let auth = getAuth(app);

        signInWithEmailAndPassword(auth, Username, Password)
          .then((userCredential) => {
            localStorage.setItem('token', userCredential.user.accessToken);

            if (poolDataLocal.accessToken !== userCredential.user.accessToken) {
              poolDataLocal.accessToken = userCredential.user.accessToken;
            }

            setAuthObj(auth);
            setAuthed(true);
            resolve(userCredential.user);
          })
          .catch((error) => {
            const errorMessage = error.message;
            console.log("Login error", error);
            reject({ message: errorMessage });
          });
      });
    }
  }
}

const safeParse = (key, back = {}) => {
  try {
      return JSON.parse(localStorage[key] || JSON.stringify(back));
  } catch (error) {
      console.error(`Error parsing key: ${key}`, error);
      return back;
  }
};

const populateTenantInfo = ()=>{
  if(appf_tenant_info.client_id){
    try{
        const tokenKeys = safeParse(`msal.token.keys.${appf_tenant_info.client_id}`);
      if(Object.keys(tokenKeys).length > 0){
        const [accessTokenKey, idTokenKey, refreshTokenKey] = [tokenKeys.accessToken[0], tokenKeys.idToken[0], tokenKeys.refreshToken[0]];
      
        const accountKeys = safeParse("msal.account.keys");
        const accountKey = accountKeys[0];
      
        appf_tenant_info.session = {
            accessToken: safeParse(accessTokenKey).secret,
            idToken: safeParse(idTokenKey).secret,
            refreshToken: safeParse(refreshTokenKey).secret,
            accessTokenData: safeParse(accessTokenKey),
            idTokenData: safeParse(idTokenKey),
            refreshTokenData: safeParse(refreshTokenKey),
            accountKey,
            accountInfo: safeParse(accountKey),
            activeAccount: localStorage[`msal.${appf_tenant_info.client_id}.active-account`] || null,
            ids: safeParse(`msal.${appf_tenant_info.client_id}.active-account-filters`, []),
        }; 
        // console.log(appf_tenant_info.session)
      }
    }catch(e){
      console.log(e)
    }
  }
}

populateTenantInfo()

function useAuthAzure() {
  const [authed, setAuthed] = useState( localStorage["msal.account.keys"] ?JSON.parse(localStorage["msal.account.keys"]).length !==0 : false );
  useEffect(()=>{
    let tInfo = appf_tenant_info;
    let localPoolData = poolData;
    let localAuth = authed;
    populateTenantInfo();

    poolData.accessToken = tInfo.client_id?(localStorage["msal.account.keys"] ?(tInfo.session ?tInfo.session.accessToken:""):""):"";

    if(poolData.accessToken.length>0){
      let interval = setInterval(()=>{
        populateTenantInfo();
      
        localPoolData.accessToken = tInfo.client_id?(localStorage["msal.account.keys"] ?(tInfo.session ?tInfo.session.accessToken:""):""):"";
        if(localPoolData.accessToken.length>0){
          setAuthed(true);
          clearInterval(interval)
        }
        // console.log(tInfo,localPoolData.accessToken)
        if( !localAuth && localPoolData.accessToken !== "" ){
          // window.location.reload()
          console.log("[1] - Reloading ... ")
        }  
      },10);
    }
  /*eslint-disable-next-line*/
  },[])

  return {
    refreshToken: () => {
      let tInfo = appf_tenant_info;
      populateTenantInfo();
      poolData.accessToken = tInfo.client_id?(localStorage["msal.account.keys"] ?(tInfo.session ?tInfo.session.accessToken:""):""):"";

      return poolData.accessToken 
    },
    getUserPool: () => {
      return {};
    },
    initConfig: () => {
    },
    authed,
    accessToken:appf_tenant_info.client_id?(localStorage["msal.account.keys"] ?(appf_tenant_info.session ?appf_tenant_info.session.accessToken:""):""):"",
    logout: () => {
      internalCleanup();

      setAuthed(false);
      window.location.pathname="/";
      setTimeout(() => {
        window.location.reload()
      }, 100);
    },
    getSession: async () => {

      return await new Promise((resolve, reject) => {
        if(appf_tenant_info.session?.accessToken ){
          poolData.accessToken = appf_tenant_info.session.accessToken;
          setAuthed(true);
          resolve(appf_tenant_info.session.accessToken);
        }else{
          populateTenantInfo()

          if(appf_tenant_info.session?.accessToken ){
            poolData.accessToken = appf_tenant_info.session.accessToken;
            setAuthed(true);
            resolve(appf_tenant_info.session.accessToken);
          }
          else{
            setAuthed(false);
            reject("Token not found")
  
          }
        }
      });
    },
    login: async () => {
      return await new Promise((resolve, reject) => {
        if(appf_tenant_info.session?.accessToken ){
          poolData.accessToken = appf_tenant_info.session.accessToken;
          setAuthed(true);
          resolve(appf_tenant_info.session.accessToken);
        }else{
          setAuthed(false);
          reject("Token not found")
        }
      });
    }
  }
}

// eslint-disable-next-line no-undef
const isFirebase = window.location.host.split(".").reverse()[0] == "app" || `${process.env.REACT_APP_isGoogle}` == `true` || `${localStorage.isGoogle}` == `true`;
export function AuthProvider(props) {
    const useAuthFn = appf_tenant_info.type=="standalone" ? useAuthStandalone :(isFirebase ? useAuthFirebase : ( appf_tenant_info.type=="azure"? useAuthAzure: useAuth) );
    const { authed, login, logout, setPool, newPass, getSession, setAuthed, refreshToken, accessToken, initConfig, getUserPool } = useAuthFn();
    return <authContext.Provider value={{ accessToken, refreshToken, authed, login, setPool, logout, newPass, getSession, setAuthed,getUserPool, initConfig }}>{props.children}</authContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.any,
  props: PropTypes.any,
  httpLink: PropTypes.any
};

export default function AuthConsumer() {
  return React.useContext(authContext);
}
